import {styled} from '@mui/material';
import Paper from '@mui/material/Paper';

export const ContractsPaper = styled(Paper)(({theme}) => ({
  width: '96%',
  margin: '0 auto',
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));
